import { BrowserRouter, useRoutes } from 'react-router-dom';
import NewHome from '../pages/NewHome';
import NotFound from '../pages/NotFound';
import AllChannels from './../pages/AllChannels';
import { Provider } from 'react-redux';
import { store } from '../stores/store';
import AuthProvider from '../providers/AuthProvider.tsx';
import ChannelsProvider from '../providers/ChannelsProvider.tsx';
import RootLayout from './layouts/RootLayout.tsx';
import NewEpgPage from '../pages/NewEpgPage.tsx';
import { NotificationProvider } from '../hooks/useNotification.tsx';
import { PlayerPage } from '../pages/PlayerPage.tsx';
import SearchPage from '../pages/SearchPage.tsx';
import NewChannelDetailsPage from '../pages/NewChannelDetailsPage.tsx';
import ChangePasswordPage from '../pages/ChangePasswordPage.tsx';
import RegisterPage from '../pages/RegisterPage.tsx';
import ConfirmRegistrationPage from '../pages/ConfirmRegistrationPage.tsx';
import LoginPage from '../pages/LoginPage.tsx';
import AccountPage from '../pages/Account/AccountPage.tsx';
import AccountChangePasswordPage from '../pages/Account/AccountChangePasswordPage.tsx';
import AccountPlayerSettingsPage from '../pages/Account/AccountPlayerSettingsPage.tsx';
import RecoverPasswordPage from '../pages/RecoverPasswordPage.tsx';
import { AccountManagementRolePage } from '../pages/Account/Admin/AccountManagementRolePage.tsx';
import { AccountManagementRoleUserPage } from '../pages/Account/Admin/AccountManagementRoleUserPage.tsx';
import { AccountManagementBannersPage } from '../pages/Account/Marketing/AccountManagementBannersPage.tsx';
import PrivacyPolicyPage from '../pages/PrivacyPolicy.tsx';
import TermsAndConditionsPage from '../pages/TermsAndConditions.tsx';
import AccountPromotionBannersEditPage from './account/marketing/banner/AccountPromotionBannersEditPage.tsx';
import ContactPage from '../pages/ContactPage.tsx';
import { GoogleAnalyticsProvider } from '../providers/GoogleAnalyticsProvider.tsx';
import { AccountRecordingManagementPage } from '../pages/Account/AccountRecordingManagementPage.tsx';
import { AccountReminderProvider } from '../providers/AccountReminderProvider.tsx';
import { MaintenancePage } from '../pages/MaintenancePage.tsx';
import { RnDProvider } from '../providers/RnDProvider.tsx';
import { AccountManagementAdminPanelPage } from '../pages/Account/Admin/AccountManagementAdminPanelPage.tsx';
import AccountFavoritesPage from '../pages/Account/AccountFavoritesPage.tsx';
import AccountProvider from '../providers/Account/AccountProvider.tsx';
import ModalProvider from '../providers/ModalProvider.tsx';
import AccountRecordingsProvider from '../providers/Account/AccountRecordingsProvider.tsx';
import AccountFavoritesProvider from '../providers/Account/AccountFavoritesProvider.tsx';
import ReverbProvider from '../providers/ReverbProvider.tsx';
import ReverbFavoritesTest from '../pages/ReverbFavoritesTest.tsx';
import AppInitializationProvider from '../providers/AppInitializationProvider.tsx';
import { AppMainStateProvider } from '../providers/AppMainStateProvider.tsx';
// import VConsole from "vconsole";

const Routes = () => {
    return useRoutes([
        { path: '*', element: <NotFound /> },
        { path: '/', element: <NewHome /> },
        { path: '/kanaly-tv/', element: <AllChannels /> },
        { path: '/kanaly-tv/:ch_id', element: <NewChannelDetailsPage /> },
        { path: '/kanaly-tv/:ch_id/player', element: <PlayerPage /> },
        { path: '/program-tv', element: <NewEpgPage /> },
        { path: '/szukaj', element: <SearchPage /> },
        // auth
        { path: '/aktywacja-konta/:token', element: <ConfirmRegistrationPage /> },
        { path: '/logowanie', element: <LoginPage /> },
        { path: '/odzyskiwanie-hasla', element: <RecoverPasswordPage /> },
        { path: '/rejestracja/:token', element: <RegisterPage /> },
        { path: '/zmiana-hasla/:token', element: <ChangePasswordPage /> },
        // account
        { path: '/konto', element: <AccountPage /> },
        { path: '/konto/zmiana-hasla', element: <AccountChangePasswordPage /> },
        { path: '/konto/odtwarzacz', element: <AccountPlayerSettingsPage /> },
        { path: '/konto/nagrania', element: <AccountRecordingManagementPage /> },
        { path: '/konto/ulubione', element: <AccountFavoritesPage /> },
        // account - admin
        { path: '/konto/uprawnienia', element: <AccountManagementRolePage /> },
        { path: '/konto/uprawnienia/uzytkownik/:user_id', element: <AccountManagementRoleUserPage /> },
        { path: '/konto/panel-administracyjny', element: <AccountManagementAdminPanelPage /> },
        // account - marketing
        { path: '/konto/banery', element: <AccountManagementBannersPage /> },
        { path: '/konto/banery/:banner_id', element: <AccountPromotionBannersEditPage /> },
        // other pages
        { path: '/polityka-prywatnosci', element: <PrivacyPolicyPage /> },
        { path: '/regulamin', element: <TermsAndConditionsPage /> },
        { path: '/kontakt', element: <ContactPage /> },
        { path: '/przerwa-technicza', element: <MaintenancePage /> },
        { path: '/favorites/test-reverb', element: <ReverbFavoritesTest /> },
    ]);
};

function App() {
    return (
        <BrowserRouter future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
        }}>
            <AppMainStateProvider>
                <GoogleAnalyticsProvider>
                    <NotificationProvider>
                        <ChannelsProvider>
                            <Provider store={store}>
                                <AccountProvider>
                                    <AuthProvider>
                                        <RnDProvider>
                                            <AccountReminderProvider>
                                                <AccountFavoritesProvider>
                                                    <AccountRecordingsProvider>
                                                        {/*<ReverbProvider>*/}
                                                            <RootLayout>
                                                                {/*<FirebaseProvider>*/}
                                                                <ModalProvider>
                                                                    <AppInitializationProvider>
                                                                        <Routes />
                                                                    </AppInitializationProvider>
                                                                </ModalProvider>
                                                                {/*</FirebaseProvider>*/}
                                                            </RootLayout>
                                                        {/*</ReverbProvider>*/}
                                                    </AccountRecordingsProvider>
                                                </AccountFavoritesProvider>
                                            </AccountReminderProvider>
                                        </RnDProvider>
                                    </AuthProvider>
                                </AccountProvider>
                            </Provider>
                        </ChannelsProvider>
                    </NotificationProvider>
                </GoogleAnalyticsProvider>
            </AppMainStateProvider>
        </BrowserRouter>
    );
}

export default App;
